import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const C = {
    p: ({ children }) => <p className="mb-2 last:mb-0 leading-relaxed">{children}</p>,
    strong: ({ children }) => <strong className="font-semibold text-white">{children}</strong>,
    ul: ({ children }) => <ul className="list-disc pl-5 mb-2 space-y-0.5">{children}</ul>,
    ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 space-y-0.5">{children}</ol>,
    code: ({ children }) => <code className="font-mono text-[12px] px-1 py-0.5 rounded bg-white/10 text-[#C4B5FD]">{children}</code>,
    pre: ({ children }) => <pre className="font-mono text-[11px] p-3 rounded bg-black/50 border border-white/10 overflow-auto mb-2">{children}</pre>,
    table: ({ children }) => <div className="overflow-auto mb-2"><table className="text-xs border border-white/10 rounded">{children}</table></div>,
    th: ({ children }) => <th className="px-3 py-1.5 text-left font-medium text-white/70 bg-white/5 border-b border-white/10">{children}</th>,
    td: ({ children }) => <td className="px-3 py-1.5 border-b border-white/5 font-mono">{children}</td>,
    a: ({ children, href }) => <a href={href} target="_blank" rel="noreferrer" className="text-[#A78BFA] underline">{children}</a>,
};

export default function Markdown({ text, testId }) {
    return (
        <div className="text-sm text-white/85" data-testid={testId}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{text || ""}</ReactMarkdown>
        </div>
    );
}
